var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ChangeTracker } from './changeTracker';
export function purge(scope, state, pointers, taskId) {
    var e_1, _a;
    var scopeState = state.data[scope];
    if (!scopeState) {
        return state;
    }
    var purgedTypes = new Set();
    var purgedStates = {};
    var tracker = new ChangeTracker(state, scope);
    for (var i = 0; i < pointers.length; i++) {
        var pointer = pointers[i];
        var bucket = pointer.bucket, id = pointer.id;
        var refState = scopeState[bucket] && scopeState[bucket][id];
        if (refState) {
            var tasks = refState.tasks;
            if (tasks.purge === taskId) {
                // Delay cloning the state until we know we need to,
                // then use this to check if we've made any changes.
                if (!purgedTypes.has(bucket)) {
                    purgedStates[bucket] = __assign({}, scopeState[bucket]);
                    purgedTypes.add(bucket);
                }
                delete purgedStates[bucket][id];
                tracker.removePointerFromTasks(pointer, tasks);
            }
        }
    }
    if (purgedTypes.size === 0) {
        return state;
    }
    var nextScopeState = __assign({}, scopeState);
    try {
        for (var _b = __values(purgedTypes.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var type = _c.value;
            if (Object.keys(purgedStates[type]).length === 0) {
                delete nextScopeState[type];
            }
            else {
                nextScopeState[type] = purgedStates[type];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var nextScopeStates = __assign({}, state.data);
    if (Object.keys(nextScopeState).length === 0) {
        delete nextScopeStates[scope];
    }
    else {
        nextScopeStates[scope] = nextScopeState;
    }
    return tracker.buildNextState(nextScopeStates);
}
//# sourceMappingURL=purge.js.map